import React from 'react';
import { Text } from 'theme-ui';
import TextList from '@components/TextList';
import { FaRegClock } from 'react-icons/fa';
import rv from '@components/utils/buildResponsiveVariant';

const formatDateToRu = date => new Date(Date.parse(date)).toLocaleDateString("ru-RU", {year: 'numeric', month: 'long', day: 'numeric'})

const CardFooterInfo = ({ variant, date, timeToRead, lang = 'en' }) => (
  <TextList nowrap>
    {date && <Text sx={{ variant: rv(variant, 'date') }}>{lang === 'ru' ? formatDateToRu(date) : date}</Text>}
    {timeToRead && (
      <Text sx={{ variant: rv(variant, 'timeToRead') }}>
        <FaRegClock css={{ verticalAlign: 'middle' }} /> {timeToRead} {lang === 'ru' ? 'мин' : 'min'}
      </Text>
    )}
  </TextList>
);

export default CardFooterInfo;
